import {MODAL_SEARCH_PARAM_KEY} from '../../../website-ui/constants/url';

const LIMIT_COUNTRIES = 6;

export const getIconSportUrl =
  (name, pathToSportIcons = 'https://cdn.nur.kz/static/olympics/icons/') => `${pathToSportIcons}${name}.svg`;

export const getPhotoAthletUrl =
  (name, pathToAthletPhotos = 'https://cdn.nur.kz/static/olympics/photos/', extension = 'png') =>
    `${pathToAthletPhotos}${name}.${extension}`;

export const getCountryIconUrl = name => `https://cdn.nur.kz/static/countries/${name}.svg`;

export const getTagUrl = (domain, slug) => `https://${domain}/tags/${slug}/`;

export const fetchData = ({domain = window.Site?.sportDomain, url}) => {
  if (!domain) {
    return Promise.reject('Olympics 2020: empty domain');
  }

  return fetch(`${domain}${url}`, {headers: {'Content-Type': 'application/json'}})
    .then(response => (
      response.ok
        ? response.json()
        : Promise.reject(`Olympics 2020: API response status – ${response.status}`)
    ));
};

export const sortPositionCountries = list => (
  list
    .slice(0, LIMIT_COUNTRIES)
    .sort((item, nextItem) => item.position - nextItem.position)
);

export const enableScroll = () => {
  const scrollY = document.body.style.top;

  document.body.style.position = '';
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
};

export const disableScroll = () => {
  document.body.style.top = `-${window.scrollY}px`;
  document.body.style.position = 'fixed';
};

const addSearchParamToUrl = id => {
  const url = new URL(window.location.href);

  url.searchParams.set(MODAL_SEARCH_PARAM_KEY, id);

  window.history.pushState(null, null, url);
};

const removeSearchParamToUrl = () => {
  const url = new URL(window.location.href);

  url.searchParams.delete(MODAL_SEARCH_PARAM_KEY);

  window.history.pushState(null, null, url);
};

export {addSearchParamToUrl, removeSearchParamToUrl};
